const price = {
  trial: 0.01,
  subscription: 49.99
};

export default price;
